
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class OpeningBalanceGrid extends Serenity.EntityGrid<OpeningBalanceRow, any> {
        protected getColumnsKey() { return 'Finance.OpeningBalance'; }
        protected getDialogType() { return OpeningBalanceDialog; }
        protected getIdProperty() { return OpeningBalanceRow.idProperty; }
        protected getInsertPermission() { return OpeningBalanceRow.insertPermission; }
        protected getLocalTextPrefix() { return OpeningBalanceRow.localTextPrefix; }
        protected getService() { return OpeningBalanceService.baseUrl; }


        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("TransDate", "Date");
        }

        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(1);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[1].AutoPosting;
            this.editItem(<OpeningBalanceRow>{
                VoucherNo: voucherNo, 
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId, 
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 1,
                TransDate: now.toDateString(), 
                UserId: userDefinition.UserId, 
                AutoPosting: autoposting
            });
        }
    }
}